<template>
  <svg
    fill="currentColor"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path
        d="M10.9996 16H12.9996C13.5996 16 13.9996 15.6 13.9996 15V7.99995H14.9996C15.2996 7.99995 15.5996 7.89995 15.7996 7.69995C16.1996 7.29995 16.0996 6.69995 15.6996 6.29995L8.69956 0.299951C8.29956 -4.88311e-05 7.79956 -4.88311e-05 7.39956 0.299951L0.399562 6.29995C-0.000438362 6.69995 -0.100438 7.29995 0.299562 7.69995C0.399562 7.89995 0.699562 7.99995 0.999562 7.99995C1.19956 7.99995 1.99956 7.99995 1.99956 7.99995V15C1.99956 15.6 2.39956 16 2.99956 16H4.99956C5.59956 16 5.99956 15.6 5.99956 15V12H9.99956V15C9.99956 15.6 10.3996 16 10.9996 16Z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          height="16"
          width="16" />
      </clipPath>
    </defs>
  </svg>
</template>
